var map = {
	"./reaction-claps.png": "5771",
	"./reaction-claps.svg": "fa46",
	"./reaction-funny.png": "4e96",
	"./reaction-funny.svg": "73d0",
	"./reaction-love.png": "f2c9",
	"./reaction-love.svg": "f707",
	"./reaction-rocket.png": "bd7e",
	"./reaction-rocket.svg": "8047",
	"./reaction-sad.png": "d951",
	"./reaction-sad.svg": "3f4c",
	"./reaction-star-struck.png": "80bd",
	"./reaction-thumbs-down.svg": "801a",
	"./reaction-thumbs-up.png": "11e4",
	"./reaction-thumbs-up.svg": "5df7",
	"./reaction-too-fast.png": "5ec5",
	"./reaction-too-fast.svg": "d13e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce55";